import { useI18n } from 'domains/i18n/hooks'
import { className } from 'lib/css'
import Form from 'ui/components/form-controls/form'
import Input from 'ui/components/form-controls/input'

export default function TranscriptForm({ controlName, describedById }) {
  const { t } = useI18n()
  return (
    <Form noValidate="true" className={className('options__form')}>
      <Input
        id="email-id"
        name={controlName}
        type="email"
        autocomplete="email"
        className={className('transcript__input')}
        aria-describedby={describedById}
        labelClass={className('label')}
        labelText={t('options.sendTranscript.label')}
      />
      <div className={className('options__actions')}>
        <button
          type="submit"
          className={className('button', 'button--primary', 'options__submit')}
        >
          {t('options.sendTranscript.sendButtonText')}
        </button>
      </div>
    </Form>
  )
}
